module.exports = __webpack_public_path__ + "img/white-search.677f5b4e.svg";